import { render } from "./Menu.vue?vue&type=template&id=255441fe"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
script.render = render

export default script